(function () {
  if (!window.Shopify || !window.Shopify.currency) return;
  if (!window.location.pathname.includes('/collections/')) return;
  if (window.Shopify.currency.active === 'EUR') return;

  var shopCurrency = window.Shopify.currency.active;
  var rate = parseFloat(window.Shopify.currency.rate);

  function convertAll() {
    document.querySelectorAll('.search-filters__product-price--main:not([data-converted])').forEach(function(container) {
      var formatEl = container.querySelector('.search-filters__format-currency');
      if (!formatEl || !formatEl.textContent.trim()) return;

      var match = formatEl.textContent.match(/(\d+\.?\d*)/);
      if (!match) return;

      var original = parseFloat(match[1]);
      if (!original) return;

      var converted = (original * rate).toFixed(2);
      formatEl.textContent = shopCurrency + '\u00a0' + converted;
      container.setAttribute('data-converted', 'true');
    });
  }

  var observer = new MutationObserver(convertAll);
  observer.observe(document.body, { childList: true, subtree: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', convertAll);
  } else {
    convertAll();
  }
})();
